module.exports = __webpack_public_path__ + "static/media/YM56_5.68e10af5.jpg";